import React from "react";
import { observer } from "mobx-react";
import { CreditPurchaseCreateStore } from "../../store";
import { CreditPurchaseCreateForm } from "./CreditPurchaseCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type CreditPurchaseCreateProps = {
  creditPurchaseCreateStore: CreditPurchaseCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CreditPurchaseCreate: React.FC<CreditPurchaseCreateProps> =
  observer(
    ({ creditPurchaseCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={creditPurchaseCreateStore.isSaving} />
          <CreditPurchaseCreateForm
            creditPurchaseCreateStore={creditPurchaseCreateStore}
            tenantError={creditPurchaseCreateStore.errors.tenant?.message}
            onTenantChange={(value) => {
              creditPurchaseCreateStore.setTenantValue(value);
            }}
            tenantSelectedValue={
              creditPurchaseCreateStore.entityValues.showTenant
            }
            onTenantSelected={(value) => {
              creditPurchaseCreateStore.setSelectedTenant(value);
            }}
            tenantOptions={creditPurchaseCreateStore.getTenantOptions()}
            quantityError={creditPurchaseCreateStore.errors.quantity?.message}
            onQuantityChange={(value: number) => {
              creditPurchaseCreateStore.setQuantityValue(value);
            }}
            quantity={creditPurchaseCreateStore.entityValues.quantity}
            purchaseDateError={
              creditPurchaseCreateStore.errors.purchaseDate?.message
            }
            onPurchaseDateChange={(value) => {
              creditPurchaseCreateStore.setPurchaseDateValue(value);
            }}
            purchaseDate={creditPurchaseCreateStore.entityValues.purchaseDate}
            expirationDateError={
              creditPurchaseCreateStore.errors.expirationDate?.message
            }
            onExpirationDateChange={(value) => {
              creditPurchaseCreateStore.setExpirationDateValue(value);
            }}
            expirationDate={
              creditPurchaseCreateStore.entityValues.expirationDate
            }
            unitPriceError={creditPurchaseCreateStore.errors.unitPrice?.message}
            onUnitPriceChange={(value: number | undefined) => {
              creditPurchaseCreateStore.setUnitPriceValue(value);
            }}
            unitPrice={creditPurchaseCreateStore.entityValues.unitPrice}
            notesError={creditPurchaseCreateStore.errors.notes?.message}
            onNotesChange={(value: string) => {
              creditPurchaseCreateStore.setNotesValue(value);
            }}
            notes={creditPurchaseCreateStore.entityValues.notes}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={creditPurchaseCreateStore.isProcessing}
            onSave={() => creditPurchaseCreateStore.saveNewCreditPurchase()}
            onCancel={() => creditPurchaseCreateStore.cancelNewCreditPurchase()}
          />
          <ErrorDialog
            open={creditPurchaseCreateStore.errorDialogOpened}
            title={creditPurchaseCreateStore.errorTitle}
            description={creditPurchaseCreateStore.errorDescription}
            onClose={() => creditPurchaseCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
